/*
Akhila 01/05/2023 3075154998 PrePopulated static preprocessor data In Ui
Suresh Peddavoora 01/06/2023 3075154998 Fixed Accordion header Font Alignments
kavyareddy 01/10/2023 3075154998 Fixed rename issues
Ravi 03/08/2023 3075154998 rename Add Preprocessor to Add Data Transformation
*/
import React, {useState, useEffect} from 'react';
import {makeStyles} from '@material-ui/core/styles';
import Accordion from '@material-ui/core/Accordion';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import Typography from '@material-ui/core/Typography';
import ActionTable from './ActionTable';
import ConditionTable from './ConditionTable';

const useStyles = makeStyles((theme) => ({
  root: {
    'width': '100%',
    'margin': '10px 0px',
    '& .MuiAccordionDetails-root': {
      display: 'block',
      whiteSpace: 'nowrap',
      padding: '12px',
    },
    '& .MuiAccordion-root': {
      borderRadius: '0px !important',
    },
  },
  accordionDetailsStyling: {
    border: '1px solid #0000003b !important',
  },
  heading: {
    fontSize: theme.typography.pxToRem(14),
    fontWeight: 600,
    flexBasis: '50%',
    flexShrink: 0,
    marginLeft: 8,
  },
  secondaryHeading: {
    fontSize: theme.typography.pxToRem(15),
    color: theme.palette.text.secondary,
  },
  detailsText: {
    backgroundColor: '#FFF',
    padding: 10,
    boxShadow:
      '0px 2px 1px -1px rgb(0 0 0 / 20%), 0px 1px 1px 0px rgb(0 0 0 / 14%), 0px 1px 3px 0px rgb(0 0 0 / 12%)',
  },
  accountSpan: {
    'backgroundColor': '#38FA8A',
    'padding': '3px 10px',
    'borderRadius': 50,
    '& .MuiTypography-body1': {
      fontSize: '12px !important',
      fontWeight: 600,
      marginTop: '3px',
      color: '#FFF',
    },
  },
  detailsCard: {
    backgroundColor: '#fff',
  },
  processorLabel: {
    fontSize: '12px !important',
    fontWeight: '200 !important',
  },
}));

const PreprocessorGroupStatic = ({prepProcessorGroupData}) => {
  const classes1 = useStyles();

  const [data, setData] = useState({});

  useEffect(() => {
    if (prepProcessorGroupData) {
      setData(prepProcessorGroupData);
    }
  }, [prepProcessorGroupData]);
  //   const [expanded, setExpanded] = useState(false);

  return (
    <>
      <div className={classes1.root}>
        <Accordion className="accordion-styling">
          <AccordionSummary
            className={classes1.accordionDetailsStyling}
            IconButtonProps={{edge: 'start'}}
          >
            <div className="d-flex align-items-center">
              <ExpandMoreIcon />
              <span
              // style={{
              //   backgroundColor: "#61ff8c",
              //   padding: "7px 16px",
              //   borderRadius: "25px",
              //   fontWeight: "bold",
              // }}
              >
                <Typography className={classes1.heading}>
                  <span className="mr-3">
                  Transformation Group Name :{' '}
                    <span className="processor-label">{data.processorGroupCode}</span>{' '}
                  </span>
                  <span>
                    {' '}
                    Transformation Group Description :
                    <span className="processor-label"> {data.processorType} </span>{' '}
                  </span>
                </Typography>
              </span>
            </div>
          </AccordionSummary>
          <AccordionDetails>
            {data?.dmProcessorRequestList?.map((el, index) => {
              return (
                <Accordion className="accordion-styling mb-2" key={index}>
                  <AccordionSummary
                    className={classes1.accordionDetailsStyling}
                    IconButtonProps={{edge: 'start'}}
                  >
                    <div>
                      <ExpandMoreIcon />
                      <span
                        style={{
                          backgroundColor: '#61ff8c',
                          padding: '7px 16px',
                          borderRadius: '25px',
                          fontWeight: 'bold',
                        }}
                      >
                        Data Transformation {index + 1}
                      </span>
                    </div>
                    <Typography>{}</Typography>
                  </AccordionSummary>
                  <AccordionDetails>
                    <div>
                      <div className="result-expression mt-0">
                        <Typography className={classes1.heading}>
                        Processor Name : <span className="processor-label">{el.processorCode}</span>
                        </Typography>
                      </div>
                      <div className="table-header table-card-header mt-2 ">
                        <Typography className={classes1.heading}>Conditions: </Typography>
                      </div>
                      <ConditionTable data={el.dmProcessorConditionRequest} />
                      <div className="result-expression">
                        <Typography className={classes1.heading}>
                          Result Expression :{' '}
                          <span className="processor-label">{el.resultExpr}</span>
                        </Typography>
                      </div>
                      <div className="table-header table-card-header mt-2 ">
                        <Typography className={classes1.heading}>Action: </Typography>
                      </div>
                      <ActionTable data={el.dmProcessorActionRequest} />
                    </div>
                  </AccordionDetails>
                </Accordion>
              );
            })}
          </AccordionDetails>
        </Accordion>
      </div>
    </>
  );
};

export default PreprocessorGroupStatic;
